/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { CreateSalesWorkOrderRequest } from '../models/create-sales-work-order-request';
import { GetSalesWorkOrderResponse } from '../models/get-sales-work-order-response';
import { SalesWorkOrderResponse } from '../models/sales-work-order-response';
import { UpdateSalesWorkOrderRequest } from '../models/update-sales-work-order-request';

/**
 * Sales Working order APIs
 */
@Injectable({ providedIn: 'root' })
export class SalesWorkOrdersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllSalesWorkOrders()` */
  static readonly GetAllSalesWorkOrdersPath = '/api/v1/sales-work-order';

  /**
   * Get list of sales-work-order.
   *
   * Gets the list of sales work orders.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllSalesWorkOrders()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSalesWorkOrders$Response(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to following fields:
       *   - SalesWorkOrder
       */
      search?: string;

      /**
       * this adds a string search to the following fields:
       *   - salesOrder
       */
      salesOrderId?: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GetSalesWorkOrderResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      SalesWorkOrdersService.GetAllSalesWorkOrdersPath,
      'get'
    );
    if (params) {
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
      rb.query('sort', params.sort, {});
      rb.query('search', params.search, {});
      rb.query('salesOrderId', params.salesOrderId, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GetSalesWorkOrderResponse>;
        })
      );
  }

  /**
   * Get list of sales-work-order.
   *
   * Gets the list of sales work orders.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllSalesWorkOrders$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllSalesWorkOrders(
    params?: {
      /**
       * the page number.
       */
      page?: number;

      /**
       * the size of a page
       */
      size?: number;

      /**
       * sort
       */
      sort?: string;

      /**
       * This adds a string search to following fields:
       *   - SalesWorkOrder
       */
      search?: string;

      /**
       * this adds a string search to the following fields:
       *   - salesOrder
       */
      salesOrderId?: number;
    },
    context?: HttpContext
  ): Observable<GetSalesWorkOrderResponse> {
    return this.getAllSalesWorkOrders$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<GetSalesWorkOrderResponse>
        ): GetSalesWorkOrderResponse => r.body
      )
    );
  }

  /** Path part for operation `createSalesWorkOrder()` */
  static readonly CreateSalesWorkOrderPath = '/api/v1/sales-work-order';

  /**
   * Create new sales workorder.
   *
   * Create a new sales item to the backend.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSalesWorkOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSalesWorkOrder$Response(
    params: {
      body: CreateSalesWorkOrderRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<SalesWorkOrderResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      SalesWorkOrdersService.CreateSalesWorkOrderPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<SalesWorkOrderResponse>;
        })
      );
  }

  /**
   * Create new sales workorder.
   *
   * Create a new sales item to the backend.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSalesWorkOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSalesWorkOrder(
    params: {
      body: CreateSalesWorkOrderRequest;
    },
    context?: HttpContext
  ): Observable<SalesWorkOrderResponse> {
    return this.createSalesWorkOrder$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<SalesWorkOrderResponse>
        ): SalesWorkOrderResponse => r.body
      )
    );
  }

  /** Path part for operation `getSalesWorkOrderById()` */
  static readonly GetSalesWorkOrderByIdPath = '/api/v1/sales-work-orders/{id}';

  /**
   * fetch sales work order order details.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSalesWorkOrderById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesWorkOrderById$Response(
    params: {
      /**
       * The sales work order id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<SalesWorkOrderResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      SalesWorkOrdersService.GetSalesWorkOrderByIdPath,
      'get'
    );
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<SalesWorkOrderResponse>;
        })
      );
  }

  /**
   * fetch sales work order order details.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSalesWorkOrderById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSalesWorkOrderById(
    params: {
      /**
       * The sales work order id that needs to be fetched
       */
      id: number;
    },
    context?: HttpContext
  ): Observable<SalesWorkOrderResponse> {
    return this.getSalesWorkOrderById$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<SalesWorkOrderResponse>
        ): SalesWorkOrderResponse => r.body
      )
    );
  }

  /** Path part for operation `updateSalesWorkOrderById()` */
  static readonly UpdateSalesWorkOrderByIdPath =
    '/api/v1/sales-work-orders/{id}';

  /**
   * update sales work order item.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSalesWorkOrderById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSalesWorkOrderById$Response(
    params: {
      /**
       * The sales work order id that needs to be update
       */
      id: number;
      body: UpdateSalesWorkOrderRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<SalesWorkOrderResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      SalesWorkOrdersService.UpdateSalesWorkOrderByIdPath,
      'patch'
    );
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<SalesWorkOrderResponse>;
        })
      );
  }

  /**
   * update sales work order item.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSalesWorkOrderById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSalesWorkOrderById(
    params: {
      /**
       * The sales work order id that needs to be update
       */
      id: number;
      body: UpdateSalesWorkOrderRequest;
    },
    context?: HttpContext
  ): Observable<SalesWorkOrderResponse> {
    return this.updateSalesWorkOrderById$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<SalesWorkOrderResponse>
        ): SalesWorkOrderResponse => r.body
      )
    );
  }
}
